import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Button from 'gatsby-theme-core/src/components/button/index';

const StyledButton = styled(Button).attrs({ wrapper: true })``;

const Wrapper = styled.div``;

const Icon = styled.div`
  flex-shrink: 0;
  height: 45px;
  width: 45px;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    height: 54px;
    width: 54px;
  }

  @supports not (mask: url()) {
    background-image: url(${({ $icon }) => $icon});
    background-size: cover;
  }

  @supports (mask: url()) {
    background-color: ${({ theme }) => theme.primaryColor};
    mask: url(${({ $icon }) => $icon}) no-repeat center;
    mask-size: contain;
  }
`;

const Highlight = ({
  className,
  image,
  title,
  link,
}) => (
  <Wrapper className={className} as={link ? StyledButton : 'div'} to={link}>
    {image?.localFile?.childImageSharp && <Image image={image} loading="eager" />}
    {image?.ext === '.svg' && <Icon $icon={image.url} />}
    <p>{title}</p>
  </Wrapper>
);

export default styled(Highlight)`
  padding: 0.4325rem;
  gap: 0.4325rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  font-size: 0.8125rem;
  font-weight: bold;
  border-radius: 4px;
  width: 100%;
  color: ${({ theme }) => theme.fontColor};
  text-decoration: none;

  &:hover {
    ${Icon} {
      @supports (mask: url()) {
        background-color: ${({ theme }) => theme.fontColor};
      }
    }
  }

  p {
    margin: 0;
  }

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    padding: 1rem;
    gap: 0.5rem;
  }
`;
